<template>
  <div class="journey-edit-container">
    <h1>ID: {{ journeyId }}</h1>
    <!-- Add your edit content here -->
     <div>
      <p>行程流水號: {{ journeySerial }}</p>
      <p>出發時間: {{ momentTimeString(startTimestamp) }}</p>
      <p>行程天數: {{ durationDays }}</p>
      <p>開始時間陣列: {{ startTimeArray }}</p>
      <p>爬升率陣列: {{ climbRateArray }}</p>
      <p>是否為完整路線: {{ isComplete }}</p>

      <b-card v-if="!isComplete">
        <b-card-title>
          不完整的段落
        </b-card-title>
        <b-card-body>
          <p v-for="(item, index) in journeyParts" :key="index">
            路段碎片 {{ index + 1 }} :
            <span @click="partClicked(index, pindex, part)" v-for="(part, pindex) in item" :key="`${part.serial}-${part.startTimestamp}`">
              {{ part.detail.name }} ({{ part.type }}) -> 
            </span>
          </p>
        </b-card-body>
      </b-card>
      <div>
        <ul>
          <li v-for="(item, index) in compiledJourneyArray" :key="`${item.serial}-${index}`">
            <p class="mb-0">{{ index }} : {{ item.detail.name }}</p>
            <ul>
              <li>類別: {{ item.type }}</li>
              <li>流水號: {{ item.serial }}</li>
              <li>抵達時間: {{ momentTimeString(item.startTimestamp) }}</li>
              <li>離開時間: {{ momentTimeString(item.endTimestamp) }}</li>

              <li v-if="item.type === 'milestone'">
                <div v-if="compiledSplitIndexs.indexOf(index) !== -1" class="text-danger">
                  住宿點
                </div>
                <div v-else>
                  <div>
                    休息時間: {{ journeyObjectArray[index].duration }} 分鐘
                  </div>
                </div>
              </li>

            </ul>
          </li>
        </ul>
      </div>
    </div>
    <WcModal v-if="showCandidateRoutesModal">
      <div>
        <b-card>
          <b-card-body>
            <div>
              <ul>
                <li v-for="(route, index) in candidateRoutes" :key="index">
                  {{ route.name }} -> {{ route.targetMilestone.name }}
                  <a href="#" @click="linkToCandidateRoute(route)">連接到此</a>
                </li>
              </ul>
            </div>
            <div>
              <b-button @click="showCandidateRoutesModal = false">
                取消
              </b-button>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </WcModal>
  </div>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import WcModal from "../common/WcModal.vue";
import moment from "moment";

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'JourneyEditContainer',
  data() {
    return {
      id: '',
      journeySerial: -1,
      journeyObjectArray: [
        // {
        //   type: 'milestone',
        //   serial: 1,
        //   duration: 0,
        //   isRestPoint: false,
        //   routeDirection: 0,
        //   detailObject: {},
        // }
      ],
      startTimestamp: 0,
      endTimestamp: 0,
      startTimeArray: [],
      climbRateArray: [],

      candidateRoutes: [],
      showCandidateRoutesModal: false,
      focusIndex: 0,
    };
  },
  components: {
    WcModal,
  },
  props: {
    journey: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.initParse();
  },
  watch: {
    journeyObjectArray: {
      handler() {
        this.$emit('updateJourneyObjectArray', this.journeyObjectArray);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    journeyId() {
      return this.id;
    },
    durationDays() {
      return this.journeyObjectArray.filter(j => j.type === 'milestone' && j.isRestPoint).length + 1;
    },
    compiledSplitIndexs() {
      // 根據最新狀況計算出的分天點陣列
      const splitIndexs = [];
      for (let i=0;i<this.journeyObjectArray.length;i++) {
        if (this.journeyObjectArray[i].isRestPoint) {
          splitIndexs.push(i);
        }
      }
      return splitIndexs;
    },
    compiledJourneyArray() {
      // 根據最新狀況計算出的行程陣列
      const compiledArray = [];
      let timestamp = this.startTimestamp;
      let rateIndex = 0;
      for (let i=0;i<this.journeyObjectArray.length;i++) {
        const j = this.journeyObjectArray[i];
        const startTimestamp = timestamp;
        let endTimestamp = 0;
        if (j.type === 'route') {
          // 計算實際時間
          const rate = this.climbRateArray[rateIndex] || 1.0;
          if (j.routeDirection === 0) {
            endTimestamp = startTimestamp + (parseInt(j.detailObject.consuming * 60 * rate) * 1000);
          } else {
            endTimestamp = startTimestamp + (parseInt(j.detailObject.returnConsuming * 60 * rate) * 1000);
          }
        } else {
          if (j.isRestPoint) {
            // 住宿點直接用startTimeArray的時間
            endTimestamp = this.startTimeArray[rateIndex + 1];
          }
          else {
            // 休息時間
            endTimestamp = startTimestamp + j.duration * 60 * 1000;
          }
        }
        if (j.isRestPoint) {
          rateIndex += 1;
        }

        const temp = {
          type: j.type,
          serial: j.serial,
          startTimestamp: startTimestamp,
          endTimestamp: endTimestamp,
          detail: j.detailObject,
        };
        if (temp.type === 'route') {
          temp.direction = j.routeDirection;
        }
        compiledArray.push(temp);
        timestamp = endTimestamp;
      }
      return compiledArray;
    },
    journeyParts() {
      // 根據最新狀況計算出的行程段落陣列
      const ary = this.compiledJourneyArray;
      if (ary.length === 0) {
        return [];
      }

      const parts = [];
      let currentPart = [{
        ...ary[0],
        originIndex: 0,
      }];
      for (let i=1;i<ary.length;i++) {
        const nowObj = {
          ...ary[i],
          originIndex: i,
        };
        const lastObj = currentPart[currentPart.length - 1];
        if (lastObj.type === 'milestone' && nowObj.type === 'milestone') {
          // 遇到新的分段點，先存起目前段落
          parts.push(currentPart);
          currentPart = [nowObj];
        } else {
          currentPart.push(nowObj);
        }
      }
      if (currentPart.length > 0) {
        parts.push(currentPart);
      }
      return parts;
    },
    isComplete() {
      // 判斷目前行程資料是否完整
      return !(this.journeyParts.length > 1);
    },
    
  },
  methods: {
    initParse() {
      try {
        this.id = this.journey._id;
        this.journeySerial = this.journey.serial;
        this.startTimestamp = this.journey.journey[0].startTimestamp;
        this.startTimeArray.splice(0);
        this.startTimeArray.push(this.startTimestamp);
        const splitIndex = this.journey.journeySplitIndexs;
        for (let i = 0; i < this.journey.journey.length; i++) {
          const j = this.journey.journey[i];
          const isRestPoint = splitIndex.indexOf(i) !== -1;
          if (isRestPoint) {
            this.startTimeArray.push(j.endTimestamp);
          }
          const jo = {
            type: j.type,
            serial: j.serial,
            duration: j.duration,
            routeDirection: j.type === 'route' ? j.direction : 0,
            isRestPoint,
            detailObject: j.detail,
          }
          this.journeyObjectArray.push(jo);
        }
        for (const rate of this.journey.climbRateArray) {
          this.climbRateArray.push(rate);
        }
      } catch (e) {
        console.error(e);
      }
    },
    momentTimeString(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
    },
    adjustNextRestPointDuration(index, durationDist) {
      for (let i=index+1;i<this.journeyObjectArray.length;i++) {
        if (this.journeyObjectArray[i].type === 'milestone' && this.journeyObjectArray[i].isRestPoint) {
          this.journeyObjectArray[i].duration -= durationDist;
          break;
        }
      }
    },
    findIndexDayIndex(index) {
      if (index <= 0) {
        return -1;
      }
      let dayIndex = 0;
      for (let i=0;i<index;i++) {
        if (this.journeyObjectArray[i].type === 'milestone' && this.journeyObjectArray[i].isRestPoint) {
          dayIndex += 1;
        }
      }
      return dayIndex;
    },
    partClicked(partIndex, itemIndex, part) {
      // console.log('partClicked', partIndex, itemIndex, part);
      if (part.type === 'milestone' && this.journeyParts[partIndex].length -1 === itemIndex) {
        this.focusIndex = part.originIndex;
        this.handleAsyncTask(async () => {
          const list = await this.$store.dispatch('api/postPathQueryLinkedRoutesPromise', part.serial);
          this.candidateRoutes.splice(0);
          list.map(item => {
            this.candidateRoutes.push(item);
          });
          this.showCandidateRoutesModal = true;
          // console.log(list);
        });
      }
    },
    linkToCandidateRoute(route) {
      this.appendRoute(
        this.focusIndex,
        route,
        route.targetMilestone,
        true,
      );
      this.showCandidateRoutesModal = false;
      this.focusIndex = 0;
    },
    // 待討論
    setStartTimestamp(timestamp) {
      this.startTimestamp = timestamp;
      this.setLeaveTime(0, timestamp);
    },
    setRestPoint(index, isRestPoint) {
      if (this.journeyObjectArray[index].isRestPoint === isRestPoint) {
        return;
      }
      let tmpIndex = this.findIndexDayIndex(index);
      if (isRestPoint) {
        this.climbRateArray.splice(tmpIndex + 1, 0, this.climbRateArray[tmpIndex] || 1.0);
        const newTime = moment(this.startTimeArray[tmpIndex]);
        newTime.add(1, 'days');
        newTime.hour(7);
        newTime.minute(0);
        newTime.second(0);
        this.startTimeArray.splice(tmpIndex + 1, 0, newTime.valueOf());
        for (let i=tmpIndex+2;i<this.startTimeArray.length;i++) {
          const t = moment(this.startTimeArray[i]);
          t.add(1, 'days');
          this.startTimeArray.splice(i, 1, t.valueOf());
        }
      } else {
        this.climbRateArray.splice(tmpIndex+1, 1);
        this.startTimeArray.splice(tmpIndex+1, 1);
        for (let i=tmpIndex+1;i<this.startTimeArray.length;i++) {
          const t = moment(this.startTimeArray[i]);
          t.subtract(1, 'days');
          this.startTimeArray.splice(i, 1, t.valueOf());
        }
      }
      // 設定某個里程碑是否為住宿點
      this.journeyObjectArray[index].isRestPoint = isRestPoint;
    },
    setRestTime(index, minutes) {
      // 設定某個里程碑的休息時間
      if (this.journeyObjectArray[index].type !== 'milestone') {
        throw new Error('只能設定里程碑的休息時間');
      }
      if (this.journeyObjectArray[index].isRestPoint) {
        throw new Error('住宿點無法設定休息時間');
      }
      // const durationDist = parseInt(minutes) - this.journeyObjectArray[index].duration;
      this.journeyObjectArray[index].duration = parseInt(minutes);
      // this.adjustNextRestPointDuration(index, durationDist);
    },
    // 待討論
    setRestPointLeaveTime(index, leaveTimestamp) {
      // 設定某個留宿點的出發時間
      const restPoint = this.journeyObjectArray[index];
      if (restPoint.type !== 'milestone' || (!restPoint.isRestPoint && index !== 0)) {
        throw new Error('只能設定留宿點的出發時間');
      }
      const dayIndex = this.findIndexDayIndex(index);
      this.setLeaveTime(dayIndex + 1, leaveTimestamp);
      // const originArriveTimestamp = this.compiledJourneyArray[index].startTimestamp;
      // const diffMinutes = Math.floor((leaveTimestamp - originArriveTimestamp) / (60 * 1000));
      // const durationDist = diffMinutes - restPoint.duration;
      // this.journeyObjectArray[index].duration = parseInt(diffMinutes);
      // this.adjustNextRestPointDuration(index, durationDist);
    },
    setLeaveTime(index, leaveTimestamp) {
      const originStartTime = this.startTimeArray[index];
      const m1 = moment(originStartTime).hour(0).minute(0).second(0);
      const m2 = moment(leaveTimestamp).hour(0).minute(0).second(0);
      const diffDays = m2.diff(m1, 'days');
      this.startTimeArray.splice(index, 1, leaveTimestamp);
      for (let i=index+1;i<this.startTimeArray.length;i++) {
        const t = moment(this.startTimeArray[i]);
        t.add(diffDays, 'days');
        this.startTimeArray.splice(i, 1, t.valueOf());
      }
    },
    removeMilestone(index) {
      if (this.journeyObjectArray.length <= 1) {
        throw new Error('行程中至少要有一個里程碑');
      }
      const restPoint = this.journeyObjectArray[index];
      if (restPoint.type !== 'milestone') {
        throw new Error('只能刪除里程碑');
      }
      if (restPoint.isRestPoint) {
        throw new Error('無法刪除住宿點');
      }

      if ((index + 1) < this.journeyObjectArray.length) {
        if (this.journeyObjectArray[index + 1].type === 'route') {
          // 如果下一個是路線，則一併刪除
          this.journeyObjectArray.splice(index + 1, 1);
        }
      }
      // this.adjustNextRestPointDuration(index, restPoint.duration);
      this.journeyObjectArray.splice(index, 1);
      if (index > 0 && this.journeyObjectArray[index - 1].type === 'route') {
        // 如果前一個是路線，則一併刪除
        this.journeyObjectArray.splice(index - 1, 1);
      }
    },
    removeRoute(index) {
      if (this.journeyObjectArray[index].type !== 'route') {
        throw new Error('只能刪除路線');
      }
      // this.adjustNextRestPointDuration(index, this.journeyObjectArray[index].duration);
      this.journeyObjectArray.splice(index, 1);
    },
    setClimbRate(index, rate) {
      try {
        this.climbRateArray.splice(index, 1, parseFloat(rate));
      } catch (error) {
        throw new Error('無法設定爬升率');
      }
    },
    appendRoute(targetIndex, route, milestone, link) {
      const target = this.journeyObjectArray[targetIndex];
      if (target.type !== 'milestone') {
        throw new Error('只能在里程碑後方加入路線');
      }
      let direction = 0;
      if (route.startMilestone === target.serial && route.endMilestone === milestone.serial) {
        direction = 0;
      } else if (route.startMilestone === milestone.serial && route.endMilestone === target.serial) {
        direction = 1;
      } else {
        throw new Error('所選路線與里程碑不符');
      }
      this.journeyObjectArray.splice(targetIndex + 1, 0, {
        type: 'route',
        serial: route.serial,
        duration: direction === 0? route.consuming : route.returnConsuming,
        isRestPoint: false,
        routeDirection: direction,
        detailObject: route,
      });

      // console.log(this.journeyObjectArray[targetIndex + 2]);
      // console.log(milestone);
      if (link && this.journeyObjectArray[targetIndex + 2].type === 'milestone' && this.journeyObjectArray[targetIndex + 2].detailObject.serial === milestone.serial) {
        // 連接  不做事
      } else {
        this.journeyObjectArray.splice(targetIndex + 2, 0, {
          type: 'milestone',
          serial: milestone.serial,
          duration: 0,
          isRestPoint: false,
          routeDirection: 0,
          detailObject: milestone,
        });
      }
    },
    generateSaveFormat() {
      // 產生儲存用的格式
      const startTimeMoment = moment(this.startTimestamp);
      const saveJourneyArray = [];
      for (let i=0;i<this.compiledJourneyArray.length;i++) {
        const j = this.compiledJourneyArray[i];
        const tmp = { ... j};
        delete tmp.detail;
        saveJourneyArray.push(tmp);
      }
      const savingData = {
        serial: this.journey.serial,
        startDate: startTimeMoment.format('YYYY-MM-DD'),
        endDate: startTimeMoment.add(this.durationDays - 1, 'days').format('YYYY-MM-DD'),
        durationDays: this.durationDays,
        // climbRate: this.generatedJourney.climbRate,
        climbRateArray: [ ... this.climbRateArray],
        journeySplitIndexs: [ ... this.compiledSplitIndexs],
        journey: saveJourneyArray,
      };
      return savingData;
    },
    
  }
};
</script>